export default "__VITE_ASSET__DnEjqaa8__"